import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@lt/localization';
import FlightTransferInfo from './FlightTransferInfo';

const baseCls = 'checkout-flight-route-hint';

const FlightTransferHint = ({ transition, transition_time }) => {
  const { t } = useTranslation();
  if (!(transition || transition_time)) {
    return (
      <div className={baseCls}>
        <p>{t('checkout.flight.transfer.noData')}</p>
      </div>
    );
  }

  return (
    <div className={baseCls}>
      <p>
        <strong>
          {/* TODO: обработать 2 пересадки, когда будут данные */}
          <span className="text-rounded text-rounded_blue">1</span>
          {` ${t('checkout.flight.transfer.text')}:`}
        </strong>
      </p>
      <FlightTransferInfo
        transition={transition}
        transitionTime={transition_time}
      />
    </div>
  );
};

FlightTransferHint.defaultProps = {
  transition: null,
  transition_time: null,
};

FlightTransferHint.propTypes = {
  transition: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  transition_time: PropTypes.shape({
    departure: PropTypes.string,
    arrival: PropTypes.string,
  }),
};

export default FlightTransferHint;
